import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import mainImg from "../../../assets/images/Home/main-img.png";
import cartempty from "../../../assets/images/cartempty.png";
import {
  Container,
  Modal,
  Form,
  Button,
  Card,
  CardHeader,
} from "react-bootstrap";
import axios from "axios";
import swal from "sweetalert";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BookCart = () => {
  const navigate = useNavigate();
  const [Booklist, setBooklist] = useState([]);
  const [imagePath, setImagePath] = useState("");
  const [fooder, setfooder] = useState("");
  const bookNames = Booklist.map((b) => b.title).join(", ");
  const [showModal, setShowModal] = useState(false);
  const [address, setAddress] = useState({
    address_line1: "",
    address_line2: "",
    city: "",
    state: "",
    pincode: "",
    country: "",
  });
  const [loading, setLoading] = useState(false);
  const [bgImage, setBgImage] = useState("");
  const user_id = localStorage.getItem("user_id");
  const username = localStorage.getItem("username");

  useEffect(() => {
    fetchBookList();
    fetchFooter();
    bannerimg();
    const savedAddress = localStorage.getItem("user_address");
    if (savedAddress) setAddress(JSON.parse(savedAddress));
  }, []);

  const fetchBookList = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/book-cart-list`,
        { user_id }
      );
      const rawBooks = res.data?.data || [];
      setImagePath(res.data?.imagePath || "");

      const grouped = {};
      rawBooks.forEach((book) => {
        if (grouped[book.book_id]) {
          grouped[book.book_id].quantity += parseInt(book.quantity);
          grouped[book.book_id].cart_ids.push(book.cart_id);
        } else {
          grouped[book.book_id] = {
            ...book,
            quantity: parseInt(book.quantity),
            cart_ids: [book.cart_id],
          };
        }
      });
      setBooklist(Object.values(grouped));
    } catch (err) {
      console.error(err);
    }
  };
  const bannerimg = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/home-seeting-list`
      );

      const baseUrl = res.data.imagePath;
      const courseImage = res.data.home_setting[0]?.course_image;

      // Full image URL
      const fullUrl = baseUrl + courseImage;

      setBgImage(fullUrl);
    } catch (error) {
      console.error("Error fetching banner:", error);
    }
  };
  const fetchFooter = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/site-setting`
      );
      setfooder(res.data.data);
    } catch (err) {}
  };

  const bookcount = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/book-cart-count`,
        { user_id }
      );
      localStorage.setItem("cartCount", res.data.cartCount || 0);
      window.dispatchEvent(new Event("cartUpdated"));
    } catch (err) {}
  };

  const increaseQty = async (book) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/book-cart`,
        { user_id, book_id: book.book_id, quantity: "1" }
      );
      if (res.data.success === "1") {
        toast.success("Quantity increased!");
        fetchBookList();
        bookcount();
      }
    } catch (err) {
      toast.error("Failed to increase quantity");
    }
  };

  const decreaseQty = async (book) => {
    try {
      if (book.cart_ids.length > 0) {
        const deleteId = book.cart_ids[book.cart_ids.length - 1];
        const res = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/book-cart-delete`,
          { id: deleteId }
        );
        if (res.data.success === "1") toast.success("Quantity decreased!");
        fetchBookList();
        bookcount();
      }
    } catch (err) {
      toast.error("Failed to decrease quantity");
    }
  };

  const removeItem = async (book) => {
    try {
      await Promise.all(
        book.cart_ids.map((id) =>
          axios.post(`${process.env.REACT_APP_BASE_URL}/book-cart-delete`, {
            id,
          })
        )
      );
      toast.success("Item removed!");
      fetchBookList();
      bookcount();
    } catch (err) {
      toast.error("Failed to remove item");
    }
  };

  const handleBuyNow = () => {
    if (Booklist.length === 0) {
      toast.error("Cart is empty!");
      return;
    }
    setShowModal(true);
  };

  const cartTotal = Booklist.reduce(
    (sum, b) => sum + (b.manual_price || b.price) * b.quantity,
    0
  );

  // Load Razorpay script dynamically
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  // Razorpay Payment Handler
  const handleRazorpayPayment = async () => {
    if (!user_id) {
      navigate("/login");
      return;
    }

    // Validate address
    const requiredFields = [
      "address_line1",
      "city",
      "state",
      "pincode",
      "country",
    ];

    for (let field of requiredFields) {
      if (!address[field]) {
        swal("Error", `Please enter ${field.replace("_", " ")}`, "error");
        return;
      }
    }

    setLoading(true);

    try {
      // Load Razorpay script
      const res = await loadRazorpayScript();
      if (!res) {
        toast.error("Razorpay SDK failed to load. Are you online?");
        setLoading(false);
        return;
      }

      // Create order
      const orderPayload = {
        user_id,
        amount: cartTotal,
        ...address,
      };

      const orderResponse = await axios.post(
        // `https://theexcellersapi.sindoor.store/paymentapi/createOrder`,
        `${process.env.REACT_APP_BASE_URL_PAYMENT}/createOrder`,
        orderPayload
      );

      if (!orderResponse.data.success) {
        toast.error("Order creation failed");
        setLoading(false);
        return;
      }

      const { razorpay_order_id, key_id } = orderResponse.data;

      // Razorpay options
      const options = {
        key: key_id,
        amount: orderResponse.data.amount * 100,
        currency: "INR",
        name: `${bookNames}`,
        description: `Purchase: ${bookNames}`,
        order_id: razorpay_order_id,
        contact: localStorage.getItem("mobile"),
        handler: async function (response) {
          try {
            // Verify payment on your server
            const verificationResponse = await axios.post(
              // `https://theexcellersapi.sindoor.store/paymentapi/verifyPayment`,
              `${process.env.REACT_APP_BASE_URL_PAYMENT}/verifyPayment`,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
              }
            );

            if (verificationResponse.data.success) {
              // Payment successful, place order
              await placeOrder(response);
            } else {
              toast.error("Payment verification failed");
            }
          } catch (error) {
            console.error("Payment verification error:", error);
            toast.error("Payment verification failed");
          }
        },
        prefill: {
          name: localStorage.getItem("user_name") || "Customer",
          email: localStorage.getItem("user_email") || "customer@example.com",
          contact: localStorage.getItem("mobile"),
        },
        notes: {
          address: "Book Store Office",
        },
        theme: {
          color: "#3399cc",
        },
      };

      const rzp = new window.Razorpay(options);

      rzp.on("payment.failed", function (response) {
        console.error("Payment Failed ❌", response);
        toast.error(`Payment failed: ${response.error.description}`);
        setLoading(false);
      });

      rzp.open();
      setLoading(false);
    } catch (err) {
      console.error("Payment initiation error:", err);
      toast.error("Failed to initiate payment");
      setLoading(false);
    }
  };

  const placeOrder = async (paymentResponse) => {
    try {
      const items = Booklist.map((book) => ({
        book_id: book.book_id,
        quantity: book.quantity,
        price: book.manual_price || book.price,
      }));

      const orderPayload = {
        user_id,
        total_amount: cartTotal,
        status: "1", // Paid status
        payment_id: paymentResponse.razorpay_payment_id,
        razorpay_order_id: paymentResponse.razorpay_order_id,
        razorpay_payment_id: paymentResponse.razorpay_payment_id,
        razorpay_signature: paymentResponse.razorpay_signature,
        ...address,
        items,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/book-order`,
        orderPayload
      );

      if (res.data.success === "1") {
        swal("Success", "Payment successful and order placed!", "success").then(
          async () => {
            // Clear cart after successful order
            const allCartIds = Booklist.flatMap((book) => book.cart_ids);
            await Promise.all(
              allCartIds.map((id) =>
                axios.post(
                  `${process.env.REACT_APP_BASE_URL}/book-cart-delete`,
                  { id }
                )
              )
            );

            setShowModal(false);
            fetchBookList();
            bookcount();
            localStorage.setItem("user_address", JSON.stringify(address));
          }
        );
      } else {
        swal("Error", res.data.message, "error");
      }
    } catch (err) {
      console.error("Order placement error:", err);
      swal("Error", "Something went wrong while placing your order!", "error");
    }
  };

  return (
    <section className="course cart-page">
      <div className="page_header"></div>
      <ToastContainer position="top-right" autoClose={2000} />
      <div className="rs-breadcrumbs breadcrumbs-overlay">
        <div className="breadcrumbs-img">
          <img src={bgImage} alt="Breadcrumbs bg" />
        </div>
        <div className="breadcrumbs-text white-color">
          <h1 className="page-title">My Cart</h1>
        </div>
      </div>

      {fooder.blogpermission == 1 && (
        <Container>
          <div className="cart_box">
            <div className="row">
              {Booklist.length > 0 ? (
                <div className="col-lg-8">
                  <Card className="plan_box cart shadow-sm">
                    <CardHeader className="p-2 item_box bg_light fw-semibold">
                      Cart Item
                    </CardHeader>
                    {Booklist.map((book, index) => (
                      <Card.Body className="d-flex gap-3 border border-bottom" key={index}>
                        <div className="flex-grow-1 d-flex gap-2">
                          <img
                            src={
                              book?.image
                                ? `${imagePath}${book.image}`
                                : mainImg
                            }
                            onError={(e) => (e.target.src = mainImg)}
                            alt="Book"
                            width="80"
                            height="100"
                          />
                          <div>
                            <h5>{book.title}</h5>
                            <p>₹{book.price}</p>
                          </div>
                          <div className="min_max d-flex align-items-center gap-2">
                            <button
                              className="educate-btn"
                              onClick={() => decreaseQty(book)}
                            >
                              -
                            </button>
                            <span>{book.quantity}</span>
                            <button
                              className="educate-btn"
                              onClick={() => increaseQty(book)}
                            >
                              +
                            </button>
                          </div>
                        </div>
                        <div className="add_remove d-flex gap-2 align-items-center text-end">
                          <h6>₹{book.price * book.quantity}</h6>
                          <div className="d-flex gap-2">
                            <button
                              className="educate-btn bg-primary sm"
                              onClick={() => removeItem(book)}
                            >
                              <span className="educate-btn__curve"></span>
                              Remove
                            </button>
                          </div>
                        </div>
                      </Card.Body>
                    ))}
                  </Card>
                </div>
              ) : (
                <div className="col-lg-12">
                  <div className="cardempty text-center">
                    <img src={cartempty} alt="cart empty" />
                    <p>Your Cart is Empty!</p>
                  </div>
                </div>
              )}

              {/* Cart Summary */}
              <div className="col-lg-4">
                {imagePath && imagePath !== "" && (
                  <Card className="shadow-sm payment_box">
                    <CardHeader>Payment Details</CardHeader>
                    <Card.Body className="discount_box">
                      <p>
                        Items: <b>{Booklist.length}</b>
                      </p>
                      <p>
                        Total Quantity:{" "}
                        <b>{Booklist.reduce((a, b) => a + b.quantity, 0)}</b>
                      </p>
                      <hr className="my-2" />
                      <p className="text-success">
                        Total Price: <b>₹{cartTotal}</b>
                      </p>
                      <button
                        className="educate-btn w-100 mt-3"
                        onClick={handleBuyNow}
                        disabled={Booklist.length === 0}
                      >
                        <span className="educate-btn__curve"></span>Proceed to
                        Checkout
                      </button>
                    </Card.Body>
                  </Card>
                )}
              </div>
            </div>
          </div>

          {/* Address Modal */}
          <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Enter Address</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                {[
                  "address_line1",
                  "address_line2",
                  "city",
                  "state",
                  "pincode",
                  "country",
                ].map((field, i) => (
                  <Form.Group className="mb-3" key={i}>
                    <Form.Label>{field.replace("_", " ")}</Form.Label>
                    <Form.Control
                      type="text"
                      value={address[field]}
                      onChange={(e) => {
                        const updatedAddress = {
                          ...address,
                          [field]: e.target.value,
                        };
                        setAddress(updatedAddress);
                        localStorage.setItem(
                          "user_address",
                          JSON.stringify(updatedAddress)
                        );
                      }}
                      required={field !== "address_line2"}
                    />
                  </Form.Group>
                ))}
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button
                className="educate-btn bg-primary"
                onClick={() => setShowModal(false)}
              >
                <span className="educate-btn__curve"></span>
                Cancel
              </button>
              <button
                className="educate-btn"
                onClick={handleRazorpayPayment}
                disabled={loading}
              >
                <span className="educate-btn__curve"></span>
                {loading ? "Processing..." : "Pay & Place Order"}
              </button>
            </Modal.Footer>
          </Modal>
        </Container>
      )}
    </section>
  );
};

export default BookCart;
